module Bookhus {
    export class DealsList implements IContentFilter {
        
        private containerId: string;
        private type: string;

        private total: any = 0;
        private page: any = 1;
        private pageSize: any = 20;
        private filter: ISearchCridentials;
        private checkAllowBooking: boolean;
        private html: string;
        private deals: any[];

        constructor(containerId: string, type: string, checkAllowBooking = false, html: string) {
            var self = this;
            self.containerId = containerId;
            self.type = type;
            self.checkAllowBooking = checkAllowBooking;
            self.html = html;
            self.pageSize = $('#' + containerId).data('pagesize');
            $.ajax({
                url: '/api/deallist/gettotal?type=' + type,
                type: 'get',
                data: {
                    type: 'Deal'
                },
                success: function (data) {
                    self.total = data;
                }
            });
        }

        search(filter: ISearchCridentials = null) {
            var self = this;
            self.filter = filter;

            var pricePreText = "";
            if (self.type == "Deal") {
                pricePreText = "Spar ";
            }
            $.ajaxSetup({ cache: false });
            $.getJSON('/api/deallist/get?pagenumber=' + self.page + '&rowsPerPage=' + self.pageSize + '&type=' + self.type, filter, function (deals) {
                var output = "";
                if (deals == null || deals.length === 0) {
                    output = "Der er i øjeblikket ingen afbud";
                } else {
                    self.deals = deals;
                    for (var i = 0; i < deals.length; i++) {

                        var protocol = (window.location.protocol || "http:") + '//';
                        var url = "";
                        if (deals[i].house.domain != null && deals[i].house.domain.length > 0) {
                            url = protocol + deals[i].house.domain;
                        }

                        var showPrice = deals[i].showPrice;
                        var priceTemp = '<span class="label label-as-badge label-success pull-left">[PRICE]</span>';
                        var template = '<div class="col-md-6 col-lg-4 col-xl-3">' +
                            '<div class ="spot brand-background-transparent">' +
                            '<div class ="spot-photo" [HOUSEIMAGEID]></div>' +
                            '<div class ="spot-info">' +
                            '<h1 title="[TITLE]" style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">[TITLE2]</h1>[PERIOD] [DATES]' +
                            '</div>' +
                            '<div class ="spot-price">' +
                            (showPrice === true ? priceTemp : '') +
                            `<a class="btn btn-default btn-xs btn-negative" data-command="book" data-index="[INDEX]" href="[BOOKLINK]" data-bookhusportal="${(deals[i].house.domain.length > 0 ? "show" : "")}" data-propertyowner="${deals[i].house.companyName}" data-encrypteddata="${deals[i].house.encryptedData}" data-redirectto="/book/${deals[i].house.id}">Book</a> ` +
                            `<a class="btn btn-default btn-xs btn-negative" href="[HOUSELINK]" data-bookhusportal="${(deals[i].house.domain.length > 0 ? "show" : "")}" data-propertyowner="${deals[i].house.companyName}" data-encrypteddata="${deals[i].house.encryptedData}" data-redirectto="/house/${deals[i].house.id}">Info</a>` +
                            '</div>' +
                            '</div>' +
                            '</div>';
                        output += template.replace("[HOUSEIMAGEID]", deals[i].house.id === 0 ? "" : 'style="background-image: url(' + url + '/houseimage/' + deals[i].house.imageId + '/285)"')
                            .replace("[TITLE]", deals[i].house.title)
                            .replace("[TITLE2]", deals[i].house.title)
                            .replace("[PERIOD]", deals[i].bookDescription + "<br/>")
                            .replace("[DATES]", "Book fra " + new Date(deals[i].fromdateRfc1123).formatDate("dd-mm-yy") + " til " + new Date(deals[i].todateRfc1123).formatDate("dd-mm-yy"))
                            .replace("[BOOKLINK]", deals[i].house.id === 0 ? "" : url + "/book/" + deals[i].house.id + "?date=" + new Date(deals[i].fromdateRfc1123).formatDate("dd-mm-yy"))
                            .replace("[HOUSELINK]", deals[i].house.id === 0 ? "" : url + "/house/" + deals[i].house.id)
                            .replace("[INDEX]", i.toString());
                        if (showPrice) {
                            output = output.replace("[PRICE]", pricePreText + deals[i].priceString);
                        }

                    }
                    output = '<div class="row">' + output + "</div>";

                    var buttons = "";
                    if (self.page > 1) {
                        buttons += '<button data-page="' + (self.page - 1) + '" class="btn btn-default btn-subtle-primary" style="margin-right: 5px;">Forrige</button>';
                    }
                    if (self.page * self.pageSize < self.total) {
                        buttons += '<button data-page="' +
                            (self.page + 1) +
                            '" class="btn btn-default btn-subtle-primary">Næste</button>';
                    }
                    output += '<div class="row"><div class="col-md-12" style="text-align:center;">' + buttons + '</div></div>';
                }

                $("#" + self.containerId).html(output);

                $('button[data-page]').on('click', (e) => {
                    var page = $(e.target).data('page');
                    self.page = page;
                    self.search(self.filter);
                });
                if (self.checkAllowBooking) {
                    $('[data-command="book"]').on('click', function (e) {
                        e.preventDefault();
                        var link = $(e.target).attr("href");
                        var index = parseInt($(e.target).attr("data-index"));
                        var deal = self.deals[index];
                        if (deal != null) {
                            var startdate = new Date(deal.fromdateRfc1123);
                            var enddate = new Date(deal.todateRfc1123);

                            $.getJSON("/api/booking/getbookingposibilities?houseId=" + deal.house.id + "&startdate=" + startdate.formatDate("yy-mm-dd") + "&enddate=" + enddate.formatDate("yy-mm-dd"))
                                .done(function (posibilities: IBookingposibility[]) {
                                    
                                for (var i = 0; i < posibilities.length; i++) {                                    
                                    if (self.CompareDates(new Date(posibilities[i].arrivaldateRfc1123), startdate) && self.CompareDates(new Date(posibilities[i].departuredateRfc1123), enddate) && posibilities[i].type != 2) {
                                        window.location.href = link;                                        
                                        return true;
                                    }
                                }
                                swal.fire({
                                    html: self.html,
                                    icon: 'info'
                                });
                                return false;
                            });
                        }
                    });
                }                
            });
        }

        private CompareDates(date1: Date, date2: Date): boolean {            
            date1.setUTCHours(0, 0, 0, 0);
            date2.setUTCHours(0, 0, 0, 0);
            return date1.getTime() == date2.getTime();
        }
    }
}